import { NgModule } from "@angular/core";
import { CoreModule } from "../../../core/core.module";
import { DirectivesModule } from "../../directives/directives.module";
import { PipesModule } from "../../pipes/pipes.module";
import { DemoDataModalComponent } from "./demo-modal.component";

@NgModule({
  declarations: [DemoDataModalComponent],
  imports: [CoreModule, DirectivesModule, PipesModule],
  exports: [DemoDataModalComponent],
})
export class DemoDataModalModule {}
